import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChartHoverService {
  private hoverLabelSubject = new BehaviorSubject<number | null>(null);
  hoverLabel$ = this.hoverLabelSubject.asObservable();

  setHoverLabel(label: number | null) {

    if(this.hoverLabelSubject.getValue() !== label) {
      this.hoverLabelSubject.next(label);
    }

  }
}